import { jsx } from 'react/jsx-runtime';
import { useMutationShareTokenCreate } from '../mutations/useMutationShareTokenCreate.js';
import { useMutationShareTokenDelete } from '../mutations/useMutationShareTokenDelete.js';
import { useMutationShareTokenUpdate } from '../mutations/useMutationShareTokenUpdate.js';
import { SelectPermissionRole } from './SelectPermissionRole.js';
import Select from '@fabric-app/ui/components/Select';

const SelectPermissionRoleToken = ({ shareToken, resourceId, removeLabel = "remove", canGrantPermissions, ...props }) => {
  const mutationCreateToken = useMutationShareTokenCreate();
  const mutationUpdateToken = useMutationShareTokenUpdate();
  const mutationDeleteToken = useMutationShareTokenDelete();
  const isPendingChange = mutationCreateToken.isPending || mutationUpdateToken.isPending || mutationDeleteToken.isPending;
  const handleChange = (value) => {
    if (value === "remove") {
      if (shareToken) {
        mutationDeleteToken.mutate({
          resourceId,
          shareTokenId: shareToken.id,
          email: shareToken.email
        });
      }
      return;
    }
    if (shareToken && shareToken.role !== value) {
      mutationUpdateToken.mutate({
        resourceId,
        shareTokenId: shareToken.id,
        role: value
      });
    } else if (!shareToken) {
      mutationCreateToken.mutate({
        resourceId,
        role: value
      });
    }
  };
  return /* @__PURE__ */ jsx(SelectPermissionRole, {
    isLoading: isPendingChange,
    value: shareToken?.role || "remove",
    onChange: handleChange,
    canGrantPermissions,
    ...props,
    children: /* @__PURE__ */ jsx(Select.ItemOption, {
      value: "remove",
      children: removeLabel
    })
  });
};

export { SelectPermissionRoleToken };
//# sourceMappingURL=SelectPermissionRoleToken.js.map
